<template>
  <div>
    <div
      class="card with-triangle bottom margin-bottom-2xl"
      style="--triangle-color: var(--fa-navy)"
    >
      <div class="header padding-x-xl padding-y-lg">
        <h3
        v-if="isActivePro && !isActiveProPlus"
          class="text-uppercase text-nowrap margin-bottom-2xs"
          :style="`letter-spacing: var(--letter-spacing-2xl); color: var(--fa-teal); font-weight: var(--font-weight-black)`"
        >
          New Pro+ Packs
        </h3>
        <h3
        v-else
          class="text-uppercase text-nowrap margin-bottom-2xs"
          :style="`letter-spacing: var(--letter-spacing-2xl); color: var(--fa-teal); font-weight: var(--font-weight-black)`"
        >
          Font Awesome 7
        </h3>
        <p
          class="strong"
          style="font-size: var(--font-size-lg)"
        >
          Now Available!
        </p>
      </div>
    </div>

    <div
      v-if="isActiveProPlus"
      class="disabled button flat block margin-bottom-2xl with-border"
      style="--button-disabled-opacity: 1; --button-disabled-background: var(--fa-lt-gravy)"
    >
      <font-awesome-icon
        :icon="$v7.solid.faPartyHorn"
        size="lg"
      />
      You've got a Pro+ Plan!
    </div>

    <site-link
      v-else
      :to="{ name: 'plans' }"
      class="button teal block margin-bottom-2xl"
      @click.native="purchaseFlowEvent('v7preorder_button_click', { context: 'home_view', location: 'hero' })"
    >
      <font-awesome-icon
        :icon="$v7.solid.faClock"
        size="xl"
        class="margin-right-sm"
      />
      Upgrade to Pro+
    </site-link>

    <site-link
      v-if="isBacker && !isActivePro"
      :to="{ name: 'account' }"
      class="button block margin-bottom-2xl"
      @click.native="purchaseFlowEvent('your_kits_button_click', { context: 'home_view', location: 'hero' })"
    >
      <font-awesome-icon
        :icon="$v7.solid.faUserCircle"
        size="lg"
        class="margin-right-sm"
      />
      Your Account
    </site-link>

    <site-link
      v-else-if="hasAccount"
      :to="{ name: 'kits' }"
      class="button block margin-bottom-2xl"
      @click.native="purchaseFlowEvent('your_kits_button_click', { context: 'home_view', location: 'hero' })"
    >
      <font-awesome-icon
        :icon="$v7.solid.faSuitcase"
        size="lg"
        class="margin-right-sm"
      />
      Your Kits
    </site-link>

    <site-link
      v-else
      :to="{ name: 'start' }"
      class="button block margin-bottom-2xl"
      @click.native="purchaseFlowEvent('start_for_free_button_click', { context: 'home_view', location: 'hero' })"
    >
      <font-awesome-icon
        :icon="$v7.solid.faGlobe"
        size="lg"
        class="margin-right-sm"
      />
      Start for Free
    </site-link>

    <p
      v-if="isActiveProPlus"
      class="tablet:size-sm text-center margin-bottom-2xl"
    >
      With your Pro+ plan, you have access to all of Font Awesome 7, including our new Pro+ icon packs, custom icons, and other services.
    </p>

    <p
      v-else-if="isProMax"
      class="tablet:size-sm text-center margin-bottom-2xl"
    >
      Upgrade to Pro Max+ to get access to the new FA 7 Pro+ icon packs, along with even more services and bandwidth.
    </p>

    <p
      v-else-if="isActivePro"
      class="tablet:size-sm text-center margin-bottom-2xl"
    >
      Upgrade to Pro+ to get access to the new FA 7 Pro+ icon packs, along with more services and bandwidth.
    </p>

    <p
      v-else
      class="tablet:size-sm text-center margin-bottom-2xl"
    >
      Get a Font Awesome Pro subscription to access version 7 - or go Pro+ and get our new Pro+ icon packs, plus more services and bandwidth.
    </p>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { get } from 'lodash'
  import { determinations } from 'app/utils/subscription'
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'SaleCta',

    mixins: [EventTrackingMixin],

    computed: {
      ...mapGetters('subscriptions', ['currentSubscription']),

      hasAccount() {
        return !!this.$account
      },

      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      determinations() {
        return determinations({ subscription: this.currentSubscription, isBacker: this.isBacker })
      },

      childProps() {
        return {
          sku: this.sku,
          isBacker: this.isBacker,
          determinations: this.determinations
        }
      },

      isActivePro() {
        return this.determinations.isPro && this.determinations.active && this.isSignedIn
      },

      isActiveProPlus() {
        const hasProPlus = this.$permits.has('accessToProPlus') && this.$dt.active

        return hasProPlus
      },

      isBacker() {
        return get(this, ['$account', 'isBacker'], false)
      },

      sku() {
        return get(this, ['$route', 'query', 'sku'])
      },

      isProMax() {
        return get(this.currentSubscription, ['plan', 'sku'], '') === 'FA-MAX'
      }
    }
  }
</script>
